import React, { lazy, useEffect } from "react";
import "./App.css";
import "@uiw/react-md-editor/markdown-editor.css";
import "@uiw/react-markdown-preview/markdown.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import { initializeAuth } from "./services/auth";
import { getToken } from "./utils/commonFunctions";

// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const PublicLeaderboard = lazy(() => import("./pages/PublicLeaderboard"));

const App = () => {
  useEffect(() => {
    // daisy UI themes initialization
    themeChange(false);
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

const AppRoutes = () => {
  const token = getToken(); // Fetch token here
  const navigate = useNavigate();

  useEffect(() => {
    initializeAuth(navigate);
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/leaderboard" element={<PublicLeaderboard />} />

      {/* Place new routes over this */}
      <Route path="/app/*" element={<Layout />} />

      <Route
        path="*"
        element={
          <Navigate to={token ? "/app/dashboard" : "/login"} replace />
        }
      />
    </Routes>
  );
};

export default App;
